import React, { Component } from 'react';
import { Icon, Select, Spin, Empty, Modal } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import networkList from '../../constants/networkList';
import postService from './../../services/httpService';
import StopwatchTimers from './../Dashboard/stopwatch';
import moment from 'moment';
const $ = require('jquery');
const { Option } = Select;

class Manager_Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': true,
            'tv_queue': [],
            'dashboard_card': {},
            'queue_token': [],
            'loadding': false,
            fetching: false,
            'counsellor': [],
            'date': moment().format('YYYY-MM'),
            'select_options': [],
            'ServiceWiseTatReport': [],
            'ServiceWiseWaitingList': [],
            'ServiceWiseLiveCountReport': [],
            stationList: [],
            stationSelect:'',
            lastRefeshTime:moment().format()
        }
    }
    componentDidMount() {
        this.setState((state) => ({ 'loadding': true, 'tv_queue': [] }), () => {
            // this.dashboardCard();
            this.stationList();
            this.ServiceWiseWaitingList();
            this.ServiceWiseLiveCountReport();
            this.ServiceWiseTatReport();
            // setInterval(() => {
            //     this.renderTvScrren();
            // }, 120000)
            // setInterval(() => {
            //     this.renderTvScrren();
            // }, 120000)
            this.tvScrren_interval = setInterval(() => {
                this.renderTvScrren();
            }, 60000)
            this.dashboardCard_interval = setInterval(() => {
                this.dashboardCard()
            },60000)
            this.tokendata_interval = setInterval(() => {
              this.renderTokendata()
            }, 60000)
            // this.renderTvScrren();
            // this.renderTokendata();
            // this.stationList();
        })
    }
 
    ServiceWiseLiveCountReport() {
        let { getServiceWiseLiveCountReport } = networkList;
        try {
            postService(getServiceWiseLiveCountReport, 'GET').then((res) => {
                if (res.status) {
                    this.setState((state) => ({
                        'ServiceWiseLiveCountReport': res['data'] ? res['data']['data'] ? res['data']['data'] : [] : [], 'counsellor': res['data'] ? res['data']['counsellors'] ? res['data']['counsellors'] : [] : []
                    }))
                }
            }).catch((error) => {
                console.log(error);
            })
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    ServiceWiseWaitingList() {
        let { date,stationSelect } = this.state;
        let { getServiceWiseWaitingList } = networkList;
        try{
            postService(getServiceWiseWaitingList, 'POST',{"counselling_station_id":stationSelect?stationSelect:''} ).then((res) => {
                if (res.data && Array.isArray(res.data)) {
                    this.setState((state) => ({
                        'ServiceWiseWaitingList': res['data']
                    }))
                }
            }).catch((error) => {
                console.log(error);
            })
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    ServiceWiseTatReport() {
        let { date } = this.state;
        try{
            let { getServiceWiseTatReport } = networkList;
            postService(getServiceWiseTatReport, 'GET').then((res) => {
                if (res['data'] && Array.isArray(res['data'])) {
                    this.setState((state) => ({
                        'ServiceWiseTatReport': res['data']
                    }))
                }
            }).catch((error) => {
                console.log(error);
            })
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    dashboardCard() {
        let { date,stationSelect } = this.state;
        let { getDashboardCardsInfo } = networkList;
        try{
            postService(getDashboardCardsInfo, 'POST',{"counselling_station_id":stationSelect?stationSelect:''}).then((res) => {
                if (res.status) {
                    this.setState((state) => ({
                        'dashboard_card': res['data'][0]                     
                    }))
                }
            }).catch((error) => {
                console.log(error);
            })
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    renderTvScrren() {
        try{
            clearInterval(this.checkPatient);
            // clearInterval(this.renderTokn);
            let { stationSelect } = this.state;
            localStorage.getItem('user_data');
            let user_data = null;
            if (localStorage.getItem('user_data')) {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            let { getActiveUsersforManager } = networkList;
            postService(getActiveUsersforManager, 'POST', {"counselling_station_id": stationSelect?stationSelect:''}).then((res) => {
                if (res.status) {
                    this.setState((state) => ({
                        'tv_queue': res['data'],
                        loadding:false,
                        lastRefeshTime:moment().format()

                    }))
                }
            }).catch((error) => {
                console.log(error);
            }).finally((data) => {
                let This = this;
                // this.checkPatient = setInterval(() => {
                //     this.renderTvScrren();
                // }, 300000)
                // this.renderScr = setTimeout(function () { This.renderTvScrren() }, 3000);
            })
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    renderTokendata() {
        // clearInterval(this.checkPatient);
        let { stationSelect } = this.state;
        clearInterval(this.renderTokn);
        let { getWaitingTokensforManager } = networkList;
        try{
            postService(getWaitingTokensforManager, 'POST', {"counselling_station_id":stationSelect?stationSelect:'' }).then((res) => {
                if (res.status) {
                    this.setState((state) => ({
                        'queue_token': res['data']
                    }))
                }
            }).catch((error) => {
                console.log(error);
            }).finally((data) => {
                let This = this;
                // this.renderTokn = setInterval(() => {
                //     this.renderTokendata();
                // }, 30000)
                // this.renderTokn = setTimeout(function () { This.renderTokendata() }, 2000);
            })
        }catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    componentWillUnmount() {
        clearInterval(this.tvScrren_interval);
        clearInterval(this.dashboardCard_interval);
        clearInterval(this.tokendata_interval);

        // clearInterval(this.checkPatient);
        // clearInterval(this.renderTokn);

        // clearTimeout(this.renderScr);
        // clearTimeout(this.renderTokn);
    }

    onChange(data, value) {
        console.clear();
        console.log(data, value);

        let { assignTokenToCounsellorFromManager } = networkList;
        try{
            if (data['id'] !== null && value !== null) {
                postService(assignTokenToCounsellorFromManager, 'POST', { "data": { "token_id": data ? data['id'] ? data['id'] : null : null, 'manager_counsellor_userid': value ? value : null } }).then((res) => {
                    if (res.status) {
                        Modal.success({
                            'title': 'Success',
                            'content': 'Token Updated Successfully'
                        })
                    } else {
                        Modal.error({
                            'title': 'Error',
                            'content': 'Token is not updated'
                        })
                    }
                    this.renderTokendata();
                    this.renderTvScrren();
                }).catch((error) => {
                    console.log(error);
                })
            }
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    onFocus(privilege_id) {
        let { getUsersByPrivilegeIds } = networkList;
        let {stationSelect} =this.state
        try{
            this.setState((state) => ({ fetching: true, 'select_options': [] }), () => {
                postService(getUsersByPrivilegeIds, 'POST', { "data": { "privilege_id": privilege_id ? privilege_id : '','ui_counselling_station_id':stationSelect?stationSelect:''} }).then((res) => {
                    if (res.status) {
                        this.setState((state) => ({
                            fetching: false,
                            'select_options': (res['data'] && Array.isArray(res['data']) && res['data'].length !== 0) ?   res['data'] :   []
                        }))
                    } else {
                        this.setState((state) => ({
                            fetching: false,
                            'select_options': []
                        }))
                    }
                }).catch((error) => {
                    console.log(error);
                    this.setState((state) => ({
                        fetching: false,
                        'select_options': []
                    }))
                })
            })
        }catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    groupBytotal(key, dataArray) {
        let total = 0
        dataArray.map((data) => {
            if (key && data[key] && data[key] != '') {
                total = total + parseFloat(data[key]);
            }
        })
        return total;
    }

    stationSelect(data){
        this.setState((state) =>({stationSelect:data,loadding:true}),()=>{
            this.dashboardCard() ; 
            this.renderTokendata();
            this.renderTvScrren();
            this.ServiceWiseWaitingList();
        })
    }

    stationList = () => {
        let { getCounsellingStationsDropDown } = networkList;
        let {stationSelect}=this.state
        let user_data = ''
        try{
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService(getCounsellingStationsDropDown, 'POST', { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}).then(res => {
                if (res.status) {
                    this.setState((state) => ({ stationList: res.data, loading: false, fetching: false,stationSelect:stationSelect==''?res.data[0].id:stationSelect }), () => {
                        this.dashboardCard() ; 
                        this.renderTokendata();
                        this.renderTvScrren();
                        this.ServiceWiseWaitingList();
                    });
                }else {
                    this.setState({ stationList: [], fetching: false });
                }
            });
        }catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    refeshpage=()=>{
        this.setState((state) =>({loadding:true}),()=>{
            this.dashboardCard() ; 
            this.renderTokendata();
            this.renderTvScrren();
            this.ServiceWiseWaitingList();
        })
    }

    render() {
        let { counsellor, queue_token, tv_queue, fetching, select_options, dashboard_card, ServiceWiseWaitingList, ServiceWiseTatReport, ServiceWiseLiveCountReport,stationList ,stationSelect,lastRefeshTime, } = this.state;
        let children = [];
        if (select_options.length !== 0) {
            select_options.map((data, key) => {
                if (data.id !== null) {
                    children.push(
                        <Option key={key} value={data.user_id} disabled={data.disabled ? data.disabled : false}>{data.username
                            ? data.username
                            : data.value}</Option>
                    );
                }
            });
        }
        return (
            <div className="mt-3 mx-4 mb-5"> 
                <Spin spinning={this.state.loadding}>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2">
                            <div className="form-group">
                                <Select
                                    mode="single"
                                    showSearch
                                    style={{ width: '100%' }}
                                    onChange={this.stationSelect.bind(this)}
                                    notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                                    filterOption={false}
                                    value={stationSelect}// onSearch={this.stationList}
                                    onFocus={this
                                        .stationList
                                        .bind(this)}
                                    placeholder="Counselling Station"
                                >
                                    {stationList.map((data, key) => {
                                        return (<Option key={key} value={data.id}>{data.name}</Option>)
                                    })}
                                </Select>
                            </div>
                        </div>
                        <div className="col-xl-10 col-lg-10">
                            <p className='text-right dashboard'>Last Refreshed at : {moment(lastRefeshTime).format('hh:mm A')} <SyncOutlined className='ml-2' onClick={this.refeshpage.bind()}/> </p>
                        </div>
                    </div>

                    <div className="man-dash row">
                        <div className="col-xl-4 col-lg-4">
                            <div className="card bg1 border border-0 pt-3">
                                <div className='col-xl-4 col-lg-4 pl-0 pr-0 pt-2'>
                                    <h1>{dashboard_card['total_count'] ? dashboard_card['total_count'] : 0}</h1>
                                </div>
                                <div className='col-xl-8 col-lg-8 pl-0 pr-0'>
                                    <h2># Tokens</h2>
                                    <h2>Generated Today</h2>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-4">
                            <div className="card bg2 border border-0 pt-3">
                                <div className='col-xl-4 col-lg-4 pl-0 pr-0 pt-2'>
                                <h1>{dashboard_card['waiting_count'] ? dashboard_card['waiting_count'] : 0}</h1>
                                </div>
                                <div className='col-xl-8 col-lg-8 pl-0 pr-0'>
                                <h2># Tokens Waiting</h2>
                                <h2>In The Queue</h2>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-xl-4 col-lg-4">
                            <div className="card bg3 border border-0 pt-3">
                            <div className='col-xl-4 col-lg-4 pl-0 pr-0 pt-2'>
                                <h1>{dashboard_card['target_count'] ? dashboard_card['target_count'] : 0}</h1>
                                </div>
                                <div className='col-xl-8 col-lg-8 pl-0 pr-0'>
                                <h2># Cases Active</h2>
                                <h2>In Bill Tracking</h2>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <div className="row pt-4 mt-2 queue-cards">
                    {/* <div className="row mt-2 queue-cards"> */}
                        <div className="col-xl-12">
                            <div className="card h-100">
                                <div className="card-header bg4">
                                    Live Queue Details
                                    {/* <button className="btn bg-white btn-refresh text-uppercase float-right" title="click to fetch new data" onClick={this.renderTokendata.bind(this)}>
                                        <Icon type="reload" className="align-middle"></Icon> Refresh</button> */}
                                </div>
                                <div className="table-responsive" style={{ 'height': '260px', overflow: 'auto' }}>
                                    <table className="table table-bordered table-hover mb-0" >
                                        <thead>
                                            <tr>
                                                <td style={{ width: '10%' }}>Patient Name</td>
                                                <td style={{ width: '10%' }}>Service</td>
                                                <td style={{ width: '10%' }}>UMR</td>
                                                <td style={{ width: '15%' }}>Doctor Name</td>
                                                <td style={{ width: '15%' }}>Department Name</td>
                                                <td style={{ width: '7%' }}>Time</td>
                                                <td style={{ width: '10%' }}>Token</td>
                                                <td style={{ width: '15%' }}>Send To</td>
                                            </tr>
                                        </thead>
                                        <tbody style={{ 'height': '260px', 'overflowY': 'auto' }}>
                                            {queue_token.map((data, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td style={{ width: '10%' }}>{data['patient_name']}</td>
                                                        <td style={{ width: '10%' }}>{data['privilege_name']}</td>
                                                        <td style={{ width: '10%' }}>{data['umr']}</td>
                                                        <td style={{ width: '15%' }}>{data['doctor_name']}</td>
                                                        <td style={{ width: '15%' }}>{data['department_name']}</td>
                                                        <td style={{ width: '7%' }}>{data['token_datetime'] ? moment(data['token_datetime']).format('h:mm a') : '--'}</td>
                                                        <td style={{ width: '10%' }}>{data['current_token_count']}</td>
                                                        <td style={{ width: '15%' }}>
                                                            <Select
                                                                size={'small'}
                                                                showSearch
                                                                onChange={this
                                                                    .onChange
                                                                    .bind(this, data)}
                                                                onFocus={this
                                                                    .onFocus
                                                                    .bind(this, data['privilege_id'])}
                                                                style={{ width: '100%' }}
                                                                placeholder="Select a Councellor"
                                                                optionFilterProp="children"
                                                                // menuItemSelectedIcon={< Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                                dropdownMatchSelectWidth={false}
                                                                notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                                                    <span>
                                                                    No Active Counsellor
                                                                    </span>
                                                                }/>}
                                                                loading={false}
                                                            >
                                                                {children}
                                                            </Select>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4 mt-2 queue-cards">
                        {tv_queue.map((data, key) => {
                            let isbreack_status=false;
                            let isIdle=false;
                            let isUseActive=false;
                            if(data['break_status']==1){
                                isbreack_status=true;
                            }else if(data['break_status']==0 && data['latest_idle_time']){
                                isIdle=true;
                            }else{
                                isUseActive=true;
                            }
                            return (
                                <div className="col-xl-3 col-lg-4 mb-2" key={key}>
                                    <div className="card h-100 bg5 border border-0">
                                        <h1>{data['counsellor_name']}</h1>
                                        <h2  style={{ 'fontSize': '2pc',background:'#fff',color:'black' }}>{data['cabin_name']?data['cabin_name']:'--'}</h2>
                                        <h3  style={{ 'fontSize': '2pc' ,background:'#fff',color:'black'}}>{isbreack_status?'On Break':isIdle ?'Idle':data['current_token_count']?'Token No.':'Idle'}{isbreack_status?'':isIdle?"":isUseActive? data['current_token_count']:'--'}</h3>
                                        <h3  style={{ 'fontSize': '2pc' ,background:'#fff',color:'black'}}>{isbreack_status? <StopwatchTimers timer_data={data} lastRefeshTime={lastRefeshTime}/>:isIdle  ?<StopwatchTimers timer_data={data} lastRefeshTime={lastRefeshTime}/>:<StopwatchTimers timer_data={data} lastRefeshTime={lastRefeshTime}/>}</h3>
                                        {/* <StopwatchTimers timer_data={data} lastRefeshTime={lastRefeshTime}/> */}
                                        {/* <h4>Privileges</h4>
                                        <p>Admissions</p>
                                        <p>Financial Counselling</p>
                                        <p>Financial Counselling</p> */}
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="row pt-4 mt-2 queue-cards">
                    </div>

                    <div className="row pt-4 mt-2 card-table">
                        {/* <div className="col-xl-7">
                            <div className="card border border-0">
                                <div className="card-header text-capitalize bg8">
                                    TAT Report
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <td className="w-50">Service</td>
                                                <td>Average Waiting TAT for the Day (Minutes)</td>
                                                <td>Average Counselling TAT for the Day (Minutes)</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ServiceWiseTatReport.map((data, key) => {
                                                return (<tr key={key}>
                                                    <td>{data['privilege_name']}</td>
                                                    <td>{data['avg_waiting_tat'] ? data['avg_waiting_tat'] : 0}</td>
                                                    <td>{data['avg_counselling_tat'] ? data['avg_counselling_tat'] : 0}</td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-xl-12">
                            <div className="card border border-0">
                                <div className="card-header text-capitalize bg8">
                                    No. Of Tokens Waiting
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <td>Service</td>
                                                <td># Waiting</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ServiceWiseWaitingList.map((data, key) => {
                                                return (<tr key={key}>
                                                    <td>{data['privilege_name']}</td>
                                                    <td>{data['count']}</td>
                                                </tr>)
                                            })}
                                            <tr className="last">
                                                <td>Total</td>
                                                <td>{ServiceWiseWaitingList.reduce((a, b) => { return a + parseInt(b['count']) }, 0)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4 mt-2 card-table d-none">
                        <div className="col-xl-12">
                            <div className="card border border-0">
                                <div className="card-header text-capitalize bg8">
                                    TAT Report
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <td className="w-50">Service</td>
                                                <td>Average Waiting TAT for the Day (Minutes)</td>
                                                <td>Average Counselling TAT for the Day (Minutes)</td>
                                                {/* <td>Total (Minutes)</td> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ServiceWiseTatReport.map((data, key) => {
                                                return (<tr key={key}>
                                                    <td>{data['privilege_name']}</td>
                                                    <td>{data['avg_waiting_tat'] ? data['avg_waiting_tat'] : 0}</td>
                                                    <td>{data['avg_counselling_tat'] ? data['avg_counselling_tat'] : 0}</td>
                                                    {/* <td>{data['count'] ? data['count'] : 0}</td> */}
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Spin>
            </div>
        )
    }
}

export default Manager_Dashboard;